export default function MakePaymentIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.61975 10.5861L10.5864 2.61945"
        stroke="#FDFDFD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.40088 12.186L8.20088 11.386"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.19531 10.3925L10.7886 8.79913"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.40089 6.82598L6.82755 2.39931C8.24089 0.98598 8.94755 0.979313 10.3476 2.37931L13.6209 5.65265C15.0209 7.05265 15.0142 7.75931 13.6009 9.17265L9.17422 13.5993C7.76089 15.0126 7.05422 15.0193 5.65422 13.6193L2.38089 10.346C0.980887 8.94598 0.980887 8.24598 2.40089 6.82598Z"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33337 14.6657H14.6667"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
